import type { StateCreator } from 'zustand';
import type { AbsenceEntry } from '@abs/shared-types';
import { generateId } from '@/utils/id';

export interface AbsenceSlice {
  entries: AbsenceEntry[];

  logAbsence: (entry: Omit<AbsenceEntry, 'id' | 'isEdited' | 'createdAt' | 'updatedAt'>) => string;
  updateEntry: (id: string, updates: Partial<Omit<AbsenceEntry, 'id' | 'createdAt'>>) => void;
  deleteEntry: (id: string) => void;
  deleteEntriesByCourse: (courseId: string) => void;
  logBulkAbsences: (entries: Array<Omit<AbsenceEntry, 'id' | 'isEdited' | 'createdAt' | 'updatedAt'>>) => string[];
}

export const createAbsenceSlice: StateCreator<AbsenceSlice> = (set) => ({
  entries: [],

  logAbsence: (entryData) => {
    const id = generateId();
    const now = new Date().toISOString();
    const entry: AbsenceEntry = {
      ...entryData,
      id,
      isEdited: false,
      createdAt: now,
      updatedAt: now,
    };
    set((state) => ({ entries: [...state.entries, entry] }));
    return id;
  },

  updateEntry: (id, updates) => {
    set((state) => ({
      entries: state.entries.map((e) =>
        e.id === id
          ? { ...e, ...updates, isEdited: true, updatedAt: new Date().toISOString() }
          : e,
      ),
    }));
  },

  deleteEntry: (id) => {
    set((state) => ({
      entries: state.entries.filter((e) => e.id !== id),
    }));
  },

  deleteEntriesByCourse: (courseId) => {
    set((state) => ({
      entries: state.entries.filter((e) => e.courseId !== courseId),
    }));
  },

  logBulkAbsences: (bulkEntries) => {
    const now = new Date().toISOString();
    const newEntries: AbsenceEntry[] = bulkEntries.map((entryData) => ({
      ...entryData,
      id: generateId(),
      isEdited: false,
      createdAt: now,
      updatedAt: now,
    }));
    set((state) => ({ entries: [...state.entries, ...newEntries] }));
    return newEntries.map((e) => e.id);
  },
});
